export default "__VITE_ASSET__$Wkcd3YY__"